import SelectSingleFilterPlain from './SelectSingleFilterPlain';
import SelectSingleFilterPopup from './SelectSingleFilterPopup';
import { bool } from 'prop-types';
import React from 'react';

const SelectSingleFilter = (props) => {
    const { showAsPopup, ...rest } = props;
    return showAsPopup ? (
        <SelectSingleFilterPopup {...rest} />
    ) : (
        <SelectSingleFilterPlain {...rest} />
    );
};

SelectSingleFilter.defaultProps = {
    showAsPopup: false,
};

SelectSingleFilter.propTypes = {
    showAsPopup: bool,
};

export default SelectSingleFilter;
